import { Select } from '../ui/Select';
import { NEW_CHANNEL } from '../../lib/aiChannels';
import type { Template } from '../../types';

// '' = let Zmist decide (reuse a match, create what's missing).
export const AUTO = '';

interface ChannelOpt {
  nickname: string;
  title?: string;
}

export function ChannelSelect({ channels, value, onChange, label = 'Channel' }: { channels: ChannelOpt[]; value: string; onChange: (v: string) => void; label?: string }) {
  return (
    <Select aria-label={label} label={label} value={value} onChange={(e) => onChange(e.target.value)}>
      <option value={AUTO}>Automatic (match by name, else create)</option>
      <option value={NEW_CHANNEL}>Create a new channel</option>
      {channels.map((c) => (
        <option key={c.nickname} value={c.nickname}>
          Use #{c.nickname.replace(/^@/, '')}
        </option>
      ))}
    </Select>
  );
}

export function SchemaSelect({ templates, value, onChange, label = 'Schema' }: { templates: Template[]; value: string; onChange: (v: string) => void; label?: string }) {
  return (
    <Select aria-label={label} label={label} value={value} onChange={(e) => onChange(e.target.value)}>
      <option value={AUTO}>Automatic (reuse matching Signals, new ones in a new schema)</option>
      <option value={NEW_CHANNEL}>Create a new schema</option>
      {templates.map((t) => (
        <option key={t.nickname} value={t.nickname}>
          Use “{t.title}”
        </option>
      ))}
    </Select>
  );
}
